<template>
  <div class="main-panel">
    <top-navbar></top-navbar>

    <div class="main-center">
          <router-view></router-view>
    </div>
    <content-footer></content-footer>
  </div>
</template>
<script>
  import TopNavbar from "./TopNavbar.vue";
  import ContentFooter from "./ContentFooter.vue";

  export default {
    components: {
      TopNavbar,
      ContentFooter
    },
    data() {
      return {
      };
    },
    created() {
    },
    methods: {

    },
  };
</script>
<style lang="scss">
  .main-panel{
    float: none;
    width: 100%;
  }
  .main-center{
    background-color: rgba(249,249,249,1);
  }
  .zd{
    position: fixed;
    right: 20px;
    bottom: 50px;
    z-index: 100000;
    display: none;
    cursor: pointer;
    .el-image{
      width: 88px;
      height: 88px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/frame/main/MainLayout.vue